/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILoyaltyAutoEnrollData } from './loyalty-auto-enroll.data';
import { ILoyaltyAutoEnrollProps } from './loyalty-auto-enroll.props.autogenerated';
import { computed } from 'mobx';
import { issueLoyalty, IssueLoyaltyInput } from '@msdyn365-commerce-modules/retail-actions';
export interface ILoyaltyAutoEnrollViewProps extends ILoyaltyAutoEnrollProps<ILoyaltyAutoEnrollData> {}

/**
 *
 * LoyaltyAutoEnroll component
 * @extends {React.PureComponent<ILoyaltyAutoEnrollProps<ILoyaltyAutoEnrollData>>}
 */
class LoyaltyAutoEnroll extends React.PureComponent<ILoyaltyAutoEnrollProps<ILoyaltyAutoEnrollData>> {
    @computed
    private get isAuthenticated(): boolean {
        const {
            context: {
                request: { user }
            }
        } = this.props;
        return user && user.isAuthenticated;
    }

    public render(): JSX.Element | null {
        const {
            data: { loyaltyCard },
            context: {
                request: { apiSettings },
                actionContext
            }
        } = this.props;
        if (this.isAuthenticated && !loyaltyCard?.result?.CardNumber) {
            issueLoyalty(new IssueLoyaltyInput(apiSettings), actionContext).catch(err => console.error(err));
        }
        return null;
    }
}

export default LoyaltyAutoEnroll;
